module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_japa.a433ed08.png";